export default {
  buttons: {
    skip: 'Omite',
    back: 'Înapoi',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
    payment: {
      pending: 'Plata dvs. este în curs de procesare...',
      success: '👍 Plata dvs. a fost procesată cu succes. Vă mulțumim!',
      error:
        '⁉️A apărut o problemă cu plata dvs. sau procesarea durează mai mult decât era de așteptat. Vă rugăm reîncărcați pagina timp de 1 minut, altfel contactați suportul tehnic.',
    },
  },
};
